import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import PermissionForm from "./PermissionForm";

const PermissionModal = ({
  isModalVisible,
  handleCancel,
  handleSubmit,
  currentPermission,
  resources,
  actions,
  resourceColors,
  actionColors,
  loading,
}) => {
  const [form] = Form.useForm();
  const [customResourceInput, setCustomResourceInput] = useState("");
  const [customActionInput, setCustomActionInput] = useState("");

  useEffect(() => {
    if (currentPermission) {
      form.setFieldsValue({
        resource: currentPermission.resource,
        action: currentPermission.action,
      });
      setCustomResourceInput("");
      setCustomActionInput("");
    } else {
      form.resetFields();
    }
  }, [currentPermission, form]);

  return (
    <Modal
      title={
        <div className="flex items-center">
          <KeyOutlined className="text-lg mr-2 text-green-600" />
          <span>{currentPermission ? "Edit Permission" : "Create New Permission"}</span>
        </div>
      }
      open={isModalVisible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => handleSubmit(form.getFieldsValue(), customResourceInput, customActionInput)}
          className="bg-green-600 hover:bg-green-700"
        >
          {currentPermission ? "Update" : "Create"}
        </Button>,
      ]}
    >
      <PermissionForm
        form={form}
        currentPermission={currentPermission}
        resources={resources}
        actions={actions}
        resourceColors={resourceColors}
        actionColors={actionColors}
        customResourceInput={customResourceInput}
        setCustomResourceInput={setCustomResourceInput}
        customActionInput={customActionInput}
        setCustomActionInput={setCustomActionInput}
      />
    </Modal>
  );
};

export default PermissionModal;